import React, { useMemo, useState } from 'react';
import { buyerMobileGetAppAnchorProps } from '../constants/appLinks';

const STORAGE_KEY = 'buyerAppMobileBannerDismissed';

/** Mobile web only — dismissible strip; “Get the app” opens App Store / Play Store directly. */
const MobileBuyerAppBanner: React.FC = () => {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return false;
    return localStorage.getItem(STORAGE_KEY) !== 'true';
  });

  const { href, target, rel } = useMemo(() => buyerMobileGetAppAnchorProps(), []);

  if (!visible) return null;

  return (
    <div className="sm:hidden relative z-40 w-full border-b border-green-800/25 bg-green-700 text-white">
      <div className="flex items-center gap-2 px-3 py-3 pr-11">
        <p className="min-w-0 flex-1 text-xs leading-snug text-green-50">
          Shop faster in the{' '}
          <span className="font-semibold text-white">BuyDrop</span> app
        </p>
        <a
          href={href}
          target={target}
          rel={rel}
          className="shrink-0 rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-green-800 hover:bg-green-50"
        >
          Get the app
        </a>
      </div>
      <button
        type="button"
        onClick={() => {
          setVisible(false);
          localStorage.setItem(STORAGE_KEY, 'true');
        }}
        className="absolute right-1 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full text-green-100 hover:bg-white/15 hover:text-white"
        aria-label="Dismiss app download banner"
      >
        <i className="ri-close-line text-lg" aria-hidden />
      </button>
    </div>
  );
};

export default MobileBuyerAppBanner;
